module.exports = __webpack_public_path__ + "static/img/gb.f0487cd5.svg";